const APIs = {
  COMMENTS_ALL: 'admin/comments',
  SINGLE_COMMENT: 'admin/comments/:id',
}

export default APIs
